import Config from "services/config/config";
import callWebService, { callTypes } from "services/utils/networks/network";
import {
    LISTING,
    ADD, BY_ID
} from "./type";

export const listing = (leadId) => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        {},
        `${Config.brandActivation.helperDetails.listing}?lead_id=${leadId}`
    );
    if (res) {
        const { data } = res;
        dispatch({ type: LISTING, payload: data.response.data });
        return data.response.data;
    }
};

export const addHelper = (data) => async (dispatch) => {
    const res = await callWebService(
        callTypes.post,
        data,
        `${Config.brandActivation.helperDetails.add}`
    );
    if (res) {
        const { data } = res;
        dispatch({ type: ADD, payload: data.response });
        return data.response;
    }
};

export const byId = (id) => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        {},
        `${Config.brandActivation.helperDetails.getById}?id=${id}`
    );
    if (res) {
        const { data } = res;
        dispatch({ type: BY_ID, payload: data.response.data });
        return data.response.data;
    }
};
